import React from 'react';
import TrimModule from '../trim-module';
import { useFeatureAppConfig } from '../../hooks/use-feature-app-config';
import SpecialOffersTier1 from '../special-offers-tier-1';
import ShowroomModule from '../showroom-module';
import SpecialOffersTier2 from '../special-offers-tier-2';

export interface FeatureAppStandaloneProps {
  // Pass props if you need
}

export const FeatureAppStandalone: React.FC = () => {
  const {mode} =  useFeatureAppConfig();
  switch(mode) {
    case "trim-module": 
      return <TrimModule/>
    case "module" :
      return <ShowroomModule/>
    case "tier-1" : 
      return <SpecialOffersTier1/>
    case "tier-2": 
    return <SpecialOffersTier2/>
    default: 
      return <SpecialOffersTier1/>
  }
};
